export const LOCAL_STORAGE_KEY_HLW_FONT_STYLE = "hlwFontStyle";
